import type { SpecialCategory } from '@/types';

export interface SpecialCategoryDTO {
  id: number;
  name: string;
  short_url: string | null;
  special_category_sort_events: Array<{
    event_id: number;
    sort_order: number | null;
    special_category_id: number;
  }>;
}

export function mapDtoToSpecialCategory(dto: SpecialCategoryDTO): SpecialCategory {
  return {
    ...dto,
  };
}

export function mapDtosToSpecialCategories(dtos: SpecialCategoryDTO[]): SpecialCategory[] {
  return dtos.map(mapDtoToSpecialCategory);
}
